import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import History from '../History';
import { addHistoryDisclosureCount } from '../../../redux/slices/vdp/disclosureCount';
import ReducerConstants from '../../../_shared/constants/reducers';
import MixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import { TradeStateName, TradeContextName } from '../../../_shared/types/trade';
import { BidSource } from '../../../_shared/types/auction';
import ROUTES from '../../Routes/constants';
import useAnalytics from '../../../_shared/hooks/useAnalytics';

const HistoryContainer = ({
  disclosures,
  tradeDetails,
  tradeContext,
  tradeState
}) => {
  const track = useAnalytics();
  const disclosureResponse = disclosures;
  const [user] = useSelector(
    state => [state[ReducerConstants.AUTH]?.user],
    shallowEqual
  );

  let isLoading = true;
  let hasErrors = false;
  // Error returned from the API
  if (disclosureResponse && disclosureResponse.message) {
    isLoading = false;
    hasErrors = true;
  }

  // To maintain an Ordered List
  const historyList = [
    {
      id: 1,
      type: '',
      disclosures: []
    },
    {
      id: 2,
      type: '',
      disclosures: []
    },
    {
      id: 3,
      type: '',
      disclosures: []
    },
    {
      id: 4,
      type: '',
      disclosures: []
    }
  ];
  let histDisclosureCount = 0;
  if (disclosureResponse && disclosureResponse.disclosures) {
    isLoading = false;
    disclosureResponse.disclosures.forEach(disclosure => {
      switch (disclosure.category) {
        case 'BRANDED_STATUSED':
          if (disclosure.valid) {
            historyList[0].disclosures.push(disclosure.label);
            histDisclosureCount += 1;
          }
          if (historyList[0].type === '') {
            historyList[0].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        case 'TITLE':
          if (disclosure.valid) {
            historyList[1].disclosures.push(disclosure.label);
            histDisclosureCount += 1;
          }
          if (historyList[1].type === '') {
            historyList[1].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        case 'FLEET':
          if (disclosure.valid) {
            historyList[2].disclosures.push(disclosure.label);
            histDisclosureCount += 1;
          }
          if (historyList[2].type === '') {
            historyList[2].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        case 'DAMAGE_OTHER_HISTORY':
          if (disclosure.valid) {
            historyList[3].disclosures.push(disclosure.label);
            histDisclosureCount += 1;
          }
          if (historyList[3].type === '') {
            historyList[3].type =
              disclosureResponse.categories[disclosure.category].label;
          }
          break;
        default:
          break;
      }
    });
  }

  /**
   * Track when the user clicks on Vehicle History Report
   */
  const viewVehicleHistoryReport = () => {
    track(MixpanelConfig.names.viewVHR, {
      source: window.location.href.includes(ROUTES.BUYING)
        ? BidSource.MINI_VDP
        : BidSource.VDP_OVERLAY,
      trade_id: tradeDetails?.id,
      auction_id: tradeDetails?.auctionSummary?.id,
      history_disclosures: histDisclosureCount > 0,
      asIs: tradeDetails?.isAsIs,
      trade_state: TradeStateName[tradeState],
      user_bid_status: '',
      seller_dealer_name: tradeDetails?.dealer.displayName,
      seller_dealer_id: tradeDetails?.dealer.id,
      trade_state_section: TradeContextName[tradeContext],
      year: tradeDetails?.year,
      make: tradeDetails?.manufacturerName,
      model: tradeDetails?.modelName,
      trim: tradeDetails?.trim,
      vin: tradeDetails?.vin
    });
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      addHistoryDisclosureCount({ vehiclehistory: histDisclosureCount })
    );
  }, [disclosureResponse, histDisclosureCount, dispatch]);

  return (
    <History
      historyList={historyList}
      histDisclosureCount={histDisclosureCount}
      historyReportLink={tradeDetails?.vehicleHistoryReportUrl}
      countryId={user?.country?.id}
      isLoading={isLoading}
      hasErrors={hasErrors}
      viewVehicleHistoryReport={viewVehicleHistoryReport}
    />
  );
};

export default HistoryContainer;
